import { useNavigate } from 'react-router-dom';
import { FiClock } from 'react-icons/fi';
import { GuideCard, GuideCardContent, GuideCardHat, GuideCardIcon, GuideCardTime, GuideCardTitle } from '@/components/custom/guide';
import { BadgeTruncate } from '@/components/ui/badge';

export default function DashboardStudyGuideCard({ studyPlan, id }) {
  const navigate = useNavigate();
  const clockIconsCount = Math.floor(Math.random() * 2) + 2;
  const clockIcons = Array.from({ length: clockIconsCount }, (_, index) => (
    <GuideCardIcon>
      <FiClock key={index} />
    </GuideCardIcon>
  ));

  if (!studyPlan) return null;

  return (
    studyPlan && (
      <GuideCard
        className="mb-6 rounded-xl p-6"
        onClick={() => navigate(`/guia-de-estudos/bloco-de-estudo/${id}`)}
      >
        <GuideCardContent className="w-80 gap-0">
          <GuideCardHat>Guia de Estudos</GuideCardHat>
          <GuideCardTitle
            className="truncate text-xl"
            title={studyPlan?.title}
          >
            {studyPlan?.title}
          </GuideCardTitle>

          <BadgeTruncate
            items={studyPlan?.taxonomies}
            oneLine
            className="!mb-0 mt-1 items-center gap-2 leading-none"
          />
        </GuideCardContent>

        <GuideCardTime>{clockIcons}</GuideCardTime>
      </GuideCard>
    )
  );
}
